<template>
  <div style="background:#FAFAFA;" class="policeLato">
    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-3" v-if="isDesktop()">
      <div class="mt-5 paralax-cover-image has-background-dim">
        <p class="paralax-cover-image-text">
        <div class="content_home" style="z-index: 1!important;">
          <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_assur_plus.caution.header_title[0]') }}</span></h1>
          <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_assur_plus.caution.header_title[1]') }}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5" v-if="isMobile()">
      <div class="paralax-cover-image_mobile has-background-dim_mobile">
        <p class="paralax-cover-image-text_mobile">
        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
          <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_assur_plus.caution.header_title[0]') }}</span></h1>
          <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_assur_plus.caution.header_title[1]') }}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <div>
      <div class="container" style="background:#FAFAFA">
        <div class="container justify-content-center row text-center mb-5 mt-5">
          <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">{{ $t('devis.devis_assur_plus.caution.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_assur_plus.caution.title[1]') }}</span> {{ $t('devis.devis_assur_plus.caution.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_assur_plus.caution.title[3]') }}</span></p> <br>
        </div>
        <br>
        <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title">{{ $t('devis.devis_assur_plus.caution.stepper_title[0]') }}</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title">{{ $t('devis.devis_assur_plus.caution.stepper_title[1]') }}</div>
                  </li>
                  <li class="step" id="thirstStep">
                    <div class="step-title">{{ $t('devis.devis_assur_plus.caution.stepper_title[2]') }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="background:#FAFAFA" v-if="isMobile()">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title text-center mr-4">{{ $t('devis.devis_assur_plus.caution.header_title[0]') }}</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title text-center mr-4">{{ $t('devis.devis_assur_plus.caution.header_title[1]') }}</div>
                  </li>
                  <li class="step" id="thirstStep">
                    <div class="step-title text-center mr-4">{{ $t('devis.devis_assur_plus.caution.header_title[2]') }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>


        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mt-5 row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <div class="col-12 col-lg-12" v-show="step === 1">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content">
                                                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="mt-4 row">
                                                          <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                              <label for="Stepper28_com" class="field-label">{{ $t('devis.devis_assur_plus.caution.first_step.structure_name_label') }}</label>
                                                              <input v-model="nom" maxlength="256" :placeholder="$t('devis.devis_assur_plus.caution.first_step.structure_name_placeholder')" id="Stepper28_com" name="Step8" class="field-input">
                                                            </div>
                                                          </div>
                                                          <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                              <label for="Stepper24" class="field-label">{{ $t('devis.devis_assur_plus.caution.first_step.statut_label') }}</label>
                                                              <select v-model="Structure_legale" id="Stepper24" name="Step8" class="field-select">
                                                                <option v-for="item in details" :key="item" :value="item">{{item.libelle}}</option>
                                                              </select>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div class="mt-4 row">
                                                          <div class="col-sm-6">
                                                            <div class="field-group field-default" style="margin-top:-2px">
                                                              <label for="Stepper25" class="field-label">
                                                                {{ $t('devis.devis_assur_plus.caution.first_step.date_effet_label') }}
                                                                <!---->
                                                              </label>
                                                              <div class="input-group value-loan">
                                                                <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_assur_plus.caution.first_step.date_effet_placeholder')" id="Stepper25" @change="CalculTaxeRente()" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="col-sm-6">
                                                            <div class="field-group field-default">
                                                              <label for="Stepper28_5" class="field-label">{{ $t('devis.devis_assur_plus.caution.first_step.montant_label') }}</label>
                                                              <div class="input-group value-loan">
                                                                <input v-money="money" maxlength="11" v-model="montant" @keyup="CalculTaxeRente()" id="Stepper28_5" :placeholder="$t('devis.devis_assur_plus.caution.first_step.montant_placeholder')" name="Step8" class="field-input">
                                                                <div class="input-group-append">
                                                                  <div class="input-group-text">FCFA</div>
                                                                </div>
                                                              </div>
                                                              <div id="error">{{ errors.phone }}</div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div class="fields">
                                                        <div class="field-group justify-content-center row flex-column flex-sm-row" v-if="prime_nette>0">
                                                          <div class="justify-content-center row ml-3 mr-3">
                                                            <ul class="to-left policeLato">
                                                              <li v-if="this.montant != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.first_step.montant_caution_label') }} :
                                                                <span class="to-right font-weight-bold" style="color:#ffa409"> {{montant.toLocaleString()}} FCFA</span>
                                                              </li>

                                                              <li v-if="this.prime_nette != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.first_step.prime_nette_label') }} :
                                                                <span class="to-right font-weight-bold" style="color:#ffa409"> {{prime_nette.toLocaleString()}} FCFA</span>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix mb-3">
                                                  <div class="wizard-footer-left">
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="GetPrimeNette()" type="button" class="wizard-btn">
                                                      {{ $t('devis.devis_assur_plus.caution.first_step.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                      {{ $t('devis.devis_assur_plus.caution.first_step.bouton_souscrire_label') }}
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-lg-12" v-show="step === 2">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content">
                                                  <div role="tabpanel" id="Step2" aria-labelledby="step-Step2" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="fields">
                                                          <div class="field-title font-weight-bold">{{ $t('devis.devis_assur_plus.caution.second_step.title') }}</div>
                                                          <div class="mt-4 row">
                                                            <div class="col-sm-6">
                                                              <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28_1" class="field-label">{{ $t('devis.devis_assur_plus.caution.second_step.duree_name_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="ContractantFields.Duree" :placeholder="$t('devis.devis_assur_plus.caution.second_step.duree_name_placeholder')" id="Stepper28_1" name="Step8" class="field-input">
                                                              </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                              <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28_2" class="field-label">{{ $t('devis.devis_assur_plus.caution.second_step.beneficiaire_label') }}</label>
                                                                <input v-model="Beneficiaire" :placeholder="$t('devis.devis_assur_plus.caution.second_step.beneficiaire_placeholder')" id="Stepper28_2" name="Step8" class="field-input">
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix mb-3">
                                                  <div class="wizard-footer-left">
                                                    <button @click="returnToFistStep" type="button" class="wizard-btn">
                                                      <span class="fas fa-arrow-left"></span>
                                                      {{ $t('devis.devis_assur_plus.caution.second_step.bouton_retour_label') }}
                                                    </button>
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="uploadForDesktop()" type="button" class="wizard-btn">
                                                      {{ $t('devis.devis_assur_plus.caution.second_step.bouton_suivant_label') }}
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-lg-12 page" v-show="step === 3">
                                <div class="wizard-tab-content">
                                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                    <div>
                                      <div class="fields">
                                        <section class="section-sm-bottom-85">
                                          <div class="container mt-1">
                                            <div class="row gx-xxl-6">
                                              <div class="col-12 col-lg-8">
                                                <div class="row">
                                                  <div class="col-12">
                                                    <div class="post">
                                                      <div class="post-body">
                                                        <div>
                                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                                            <div class="form">
                                                              <div class="page">
                                                                <div class="wizard-tab-content">
                                                                  <div role="tabpanel" id="Step1_caution" aria-labelledby="step-Step1_caution" class="wizard-tab-container">
                                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_assur_plus.caution.third_step.title') }} :</div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                      <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_assur_plus.caution.third_step.souscripteur_title') }}</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                      <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_assur_plus.caution.third_step.structure_name_label') }} :
                                                                              <span class="font-weight-bold to-right">{{nom}}</span>
                                                                            </li>
                                                                            <li v-if="Structure_legale != null" class="subheading" style="list-style: none">{{ $t('devis.devis_assur_plus.caution.third_step.structure_label') }} :
                                                                              <span class="font-weight-bold to-right">{{Structure_legale.libelle}}</span>
                                                                            </li>
                                                                          </ul>
                                                                        </div>
                                                                      </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                      <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_assur_plus.caution.third_step.montant_title') }}</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                      <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li v-if="this.montant !=null" class="subheading" style="list-style: none">{{ $t('devis.devis_assur_plus.caution.third_step.montant_label') }} :
                                                                              <span v-if="this.montant !=null" class="font-weight-bold to-right">{{montant.toLocaleString()}} FCFA</span>
                                                                            </li>
                                                                          </ul>
                                                                        </div>
                                                                      </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                      <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_assur_plus.caution.third_step.periode_title') }}</p>
                                                                      </div>
                                                                    </div>

                                                                    <div class="row">
                                                                      <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                          <label for="Stepper39" class="field-label">{{ $t('devis.devis_assur_plus.caution.third_step.date_effet_label') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                          <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_assur_plus.caution.third_step.date_effet_placeholder')" v-model="dateEffet" id="Stepper39" name="Step11" class="field-input">
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                          <label for="Stepper40" class="field-label">{{ $t('devis.devis_assur_plus.caution.third_step.date_echeance_label') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                          <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_assur_plus.caution.third_step.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div class="wizard-card-footer clearfix mb-3">
                                                                  <div class="wizard-footer-left">
                                                                    <button @click="returnToSecondStep" type="button" class="wizard-btn">
                                                                      <span class="fas fa-arrow-left"></span>
                                                                      {{ $t('devis.devis_assur_plus.caution.third_step.bouton_retour_label') }}
                                                                    </button>
                                                                  </div>
                                                                  <div class="wizard-footer-right">
                                                                    <button :disabled="disabledButtonValidate" @click="CreateDevis" type="button" class="wizard-btn">
                                                                      {{ $t('devis.devis_assur_plus.caution.third_step.bouton_valider_label') }}
                                                                    </button>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <aside class="col-12 col-lg-4">
                                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                                  <div class="c-cta-block">
                                                    <div v-if="this.prime_nette !=null" class="c-cta-block__title font-weight-bold">{{ $t('devis.devis_assur_plus.caution.third_step.prime_nette_label') }}</div>
                                                    <div v-if="this.prime_nette !=null" class="c-cta-block__title"><span style="color:#5B94BC!important">{{ prime_nette.toLocaleString() }} FCFA</span></div>
                                                    <br>

                                                    <div v-if="this.accessoire !=null" class="c-cta-block__title font-weight-bold">{{ $t('devis.devis_assur_plus.caution.third_step.frais_label') }}</div>
                                                    <div v-if="this.accessoire !=null" class="c-cta-block__title"><span style="color:#5B94BC!important">{{ accessoire.toLocaleString() }} FCFA</span></div>
                                                    <br>

                                                    <div v-if="this.taxe !=null" class="c-cta-block__title font-weight-bold">{{ $t('devis.devis_assur_plus.caution.third_step.taxe_label') }}</div>
                                                    <div v-if="this.taxe !=null" class="c-cta-block__title"><span style="color:#5B94BC!important">{{ taxe.toLocaleString() }} FCFA</span></div>
                                                    <br>

                                                    <div v-if="this.monthly_payment !=null" class="c-cta-block__title font-weight-bold">{{ $t('devis.devis_assur_plus.caution.third_step.prime_ttc') }}</div>
                                                    <div v-if="this.monthly_payment !=null" class="c-cta-block__title"><span style="color:#5B94BC!important">{{ monthly_payment.toLocaleString() }} FCFA</span></div>

                                                  </div>
                                                </div>
                                              </aside>
                                            </div>
                                          </div>
                                        </section>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs v-if="isMobile()">
          <div class="mt-5" style="background:#FAFAFA">
            <div class="row" style="background:#FAFAFA">
              <div class="col-md-10" style="background:#FAFAFA">
                <div class="form" style="background:#FAFAFA">
                  <div class="page" v-show="step === 1">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                        <div>
                          <div class="fields">
                            <div class="mt-4 row">
                              <div class="col-sm-6">
                                <div class="field-group field-default mb-4 mb-sm-0">
                                  <label for="Stepper28_com" class="field-label">{{ $t('devis.devis_assur_plus.caution.first_step.structure_name_label') }}</label>
                                  <input v-model="nom" :placeholder="$t('devis.devis_assur_plus.caution.first_step.structure_name_placeholder')" id="Stepper28_com" name="Step8" class="field-input">
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div class="field-group field-default mb-4 mb-sm-0">
                                  <label for="Stepper24" class="field-label">{{ $t('devis.devis_assur_plus.caution.first_step.statut_label') }}</label>
                                  <select v-model="Structure_legale" id="Stepper24" name="Step8" class="field-select">
                                    <option v-for="item in details" :key="item" :value="item">{{item.libelle}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="mt-4 row">
                              <div class="col-sm-6">
                                <div class="field-group field-default mb-4 mb-sm-0" style="margin-top:-15px">
                                  <label for="Stepper25" class="field-label">
                                    {{ $t('devis.devis_assur_plus.caution.first_step.date_effet_label') }}
                                    <!---->
                                  </label>
                                  <div class="input-group value-loan">
                                    <date-picker :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_assur_plus.caution.first_step.date_effet_placeholder')" id="Stepper25" @change="CalculTaxeRente()" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div class="field-group field-default">
                                  <label for="Stepper28" class="field-label">{{ $t('devis.devis_assur_plus.caution.first_step.montant_label') }}</label>
                                   <div class="input-group value-loan">
                                      <input v-money="money" maxlength="11" v-model="montant" @keyup="CalculTaxeRente()" id="Stepper28" :placeholder="$t('devis.devis_assur_plus.caution.first_step.montant_placeholder')" name="Step8" class="field-input">
                                      <div class="input-group-append">
                                        <div class="input-group-text">FCFA</div>
                                      </div>
                                    </div>
                                  <div id="error">{{ errors.phone }}</div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="fields">
                            <div class="field-group justify-content-center row flex-column flex-sm-row" v-if="prime_nette>0">
                              <div class="justify-content-center row ml-3 mr-3">
                                <ul class="to-left policeLato">
                                  <li v-if="this.montant != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.first_step.montant_caution_label') }} :
                                    <span class="to-right font-weight-bold" style="color:#ffa409"> {{montant.toLocaleString()}} FCFA</span>
                                  </li>

                                  <li v-if="this.prime_nette != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.first_step.prime_nette_label') }} :
                                    <span class="to-right font-weight-bold" style="color:#ffa409"> {{prime_nette.toLocaleString()}} FCFA</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix mb-3">
                      <div class="wizard-footer-left">
                      </div>
                      <div class="wizard-footer-right">
                        <button v-if="Simule" @click="GetPrimeNette()" type="button" class="wizard-btn">
                          {{ $t('devis.devis_assur_plus.caution.first_step.bouton_simuler_label') }}
                        </button>
                        <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                          {{ $t('devis.devis_assur_plus.caution.first_step.bouton_souscrire_label') }}
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page" v-show="step === 2">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step2_mobile" aria-labelledby="step-Step2_mobile" class="wizard-tab-container">
                        <div>
                          <div class="fields">
                            <div class="fields">
                              <div class="field-title font-weight-bold">{{ $t('devis.devis_assur_plus.caution.second_step.title') }}</div>
                              <div class="mt-4 row">
                                <div class="col-sm-6">
                                  <div class="field-group field-default mb-4 mb-sm-0">
                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_assur_plus.caution.second_step.duree_name_label') }}</label>
                                    <input @keypress="onlyNumber" v-model="ContractantFields.Duree" :placeholder="$t('devis.devis_assur_plus.caution.second_step.duree_name_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                  </div>
                                </div>

                                <div class="col-sm-6">
                                  <div class="field-group field-default mb-4 mb-sm-0">
                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_assur_plus.caution.second_step.beneficiaire_label') }}</label>
                                    <input v-model="Beneficiaire" :placeholder="$t('devis.devis_assur_plus.caution.second_step.beneficiaire_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix mb-3">
                      <div class="wizard-footer-left">
                        <button @click="returnToFistStep" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{ $t('devis.devis_assur_plus.caution.second_step.bouton_retour_label') }}
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="uploadForMobile()" type="button" class="wizard-btn">
                          {{ $t('devis.devis_assur_plus.caution.second_step.bouton_suivant_label') }}
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page" v-show="step === 3">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step1_caution" aria-labelledby="step-Step1_caution" class="wizard-tab-container">
                        <div class="field-title font-weight-bold justify-content-center row">{{ $t('devis.devis_assur_plus.caution.third_step.title') }}</div>
                        <div class="mt-3 justify-content-center row">
                          <div class="justify-content-center row">
                            <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_assur_plus.caution.third_step.souscripteur_title') }}</p>
                          </div>
                        </div>
                        <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                          <div class="col-sm-12">
                            <div class="field-group field-default">
                              <ul class="to-left mb-3 mr-3 policeLato">
                                <li class="subheading" style="list-style: none">{{ $t('devis.devis_assur_plus.caution.third_step.structure_name_label') }} :
                                  <span class="font-weight-bold to-right">{{nom}}</span>
                                </li>
                                <li v-if="this.Structure_legale != null" class="subheading" style="list-style: none">{{ $t('devis.devis_assur_plus.caution.third_step.structure_label') }} :
                                  <span class="font-weight-bold to-right">{{ Structure_legale.libelle }}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="mt-3 justify-content-center row">
                          <div class="justify-content-center row">
                            <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_assur_plus.caution.third_step.montant_title') }}</p>
                          </div>
                        </div>
                        <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                          <div class="col-sm-12">
                            <div class="field-group field-default">
                              <ul class="to-left mb-3 mr-3 policeLato">
                                <li v-if="this.montant != null" class="subheading" style="list-style: none">{{ $t('devis.devis_assur_plus.caution.third_step.montant_label') }} :
                                  <span class="font-weight-bold to-right">{{ montant.toLocaleString() }} FCFA</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>


                        <div class="mt-3 justify-content-center row">
                          <div class="justify-content-center row">
                            <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_assur_plus.caution.third_step.periode_title') }}</p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper39" class="field-label">{{ $t('devis.devis_assur_plus.caution.third_step.date_effet_label') }}
                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                              <div class="input-group rate-loan">
                                <input disabled :placeholder="$t('devis.devis_assur_plus.caution.third_step.date_effet_placeholder')" v-model="dateEffet" id="Stepper39" name="Step11" class="field-input">
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper40" class="field-label">{{ $t('devis.devis_assur_plus.caution.third_step.date_echeance_label') }}
                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                              <div class="input-group rate-loan">
                                <input disabled :placeholder="$t('devis.devis_assur_plus.caution.third_step.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="fields">
                          <div class="field-group justify-content-center row flex-column flex-sm-row" v-if="prime_nette>0">
                            <div class="justify-content-center row ml-3 mr-3">
                              <ul class="to-left policeLato">
                                <li v-if="this.prime_nette != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.third_step.prime_nette_label') }} :
                                  <span class="to-right font-weight-bold" style="color:#ffa409"> {{ prime_nette.toLocaleString() }} FCFA</span>
                                </li>

                                <li v-if="this.accessoire != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.third_step.frais_label') }} :
                                  <span class="to-right font-weight-bold" style="color:#ffa409"> {{ accessoire.toLocaleString() }} FCFA</span>
                                </li>

                                <li v-if="this.taxe != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.third_step.taxe_label') }} :
                                  <span class="to-right font-weight-bold" style="color:#ffa409"> {{ taxe.toLocaleString() }} FCFA</span>
                                </li>

                                <li v-if="this.monthly_payment != null" class="subheading" style="list-style: none;">{{ $t('devis.devis_assur_plus.caution.third_step.prime_ttc') }}:
                                  <span class="to-right font-weight-bold" style="color:#5B94BC"> {{ monthly_payment.toLocaleString() }} FCFA</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="wizard-card-footer clearfix mb-3">
                      <div class="wizard-footer-left">
                        <button @click="returnToSecondStep" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{ $t('devis.devis_assur_plus.caution.third_step.bouton_retour_label') }}
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button :disabled="disabledButtonValidate" @click="CreateDevis" type="button" class="wizard-btn">
                          {{ $t('devis.devis_assur_plus.caution.third_step.bouton_valider_label') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('devis.devis_assur_plus.caution.devis_encours') }}</span>
    </div>

    <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{ $t('devis.devis_assur_plus.caution.devis_encours') }}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
    </v-dialog> -->

    <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FFA409">
            <div class="wizard-tab-content" style="background:#FFA409">
            <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                <div>
                <div class="loan-group loan-group-0" style="background:#FFA409">
                    <div class="fields text-center" style="background:#FFA409">
                        <span class="field-title font-weight-bold" style="color:#fff">{{ $t('devis.devis_assur_plus.caution.devis_encours') }}</span>
                    </div>
                    <div class="fields text-center" style="background:#FFA409">
                        <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </v-card-text>
        </v-card>
    </v-dialog> -->
    <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
    <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
  </div>
</template>
<script>
import store from "./../../../store/store";
import dayjs from "dayjs";
import Api from "./../../../services/Api";
import LoginForm from '././../../auth/Login';
import sonacData from '../../../common/sonac.json'

export default {
  name: 'Devis_caution',
  components: {
    LoginForm
  },
  data() {
    return {
      dialogLoading : false,
      disabledButtonValidate : false,
      step : 1,
      montant : 0,
      taxe : 0,
      accessoire: 25000,
      primeTTC:0,
      prime_nette : 0,
      nom : null,
      data:[],
      Structure_legale : null,


      ContractantFields: {
        dateNaissance: null,
        Duree: null,
      },
      Beneficiaire : null,
      Duree_bourse: null,
      oldDate: null,
      bottomPushNotif: false,
      disableDateAssure: true,
      Modalite: null,
      Assureur: '',
      Simule: true,
      SkipSimule: false,
      money: {
        thousands: ' ',
        precision: false,
        masked: false,
      },
      choixOffre: null,
      choixOffreFinale: null,
      dateNaiss: null,
      duree: null,
      Capital: true,
      Mensualite: false,
      Capi_souhaite: null,
      rente_an: null,
      pourcent: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
      choixCapital: {
        Capital: null,
        Mensuel: null,
      },
      dateEffet: null,
      dateEcheance: null,
      e1: 1,
      elevation: 2,
      activeStep: 0,
      checkbox: false,
      errors: {},
      aStorMap: false,
      disable: false,
      valide: null,
      age: null,
      QuestionSwitch: {
        Q1: null,
        Q2: null,
        Q3: null,
        Q4: null,
        Q5: null,
        Q6: null,
        Q7: null,
      },
      QuestionNext: {
        Q: true,
        Q1: false,
        Q2: false,
        Q3: false,
        Q4: false,
        Q5: false,
        Q6: false,
        Q7: false,
      },

      // numTelephone : '' ,
      amenities: [1, 4],
      genre: null,

      fraisLiv: 0,
      fraisPaiement: 0,
      Testons: false,
      itemsGenre: ["Homme", "Femme"],
      adresselivraison: "",
      autoHeight: true,
      x: null,
      dialogAlert: false,
      Devis_pour_souscription: [],
      mode_livraison: null,
      menuDelivrance: false,
      Calculated_response: null,
      monthly_payment: null,
      mode_payement: null,
      notifDeviParMail: null,
      countries: null,
      ville: null,
      quartier: "",
      listegaranties: [],
      marque: null,
      tableau_info_passager: [],
      nbPassager: null,
      frais_livraison: null,
      branche: null,
      continue_btn: false,
      dialogInfoPassager: false,
      dialog: false,
      city: null,
      datePickerDateNais: false,
      IsPaid: false,
      adresse: false,
      livePaper: false,
      checked: false,
      showLoginForm: false,
      animation: 'animate-in',
      NomAssure: null,
      isContractant: true,
      isAssure: false,
      isBenef: false,
      Questionnaire: false,
      QuestionnaireSuite: false,
      isPayment: false,
      menu: false,
      Capi: 0,
      Mensu: 0,
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 4000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      }, // Customized options for success toast
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 4000,
        fitToScreen: true,
        type: 'error'
      }, // Customized options for error toast

      CreatedDevis: null,
    }
  },
  methods: {
    checkToken() {
        Api().get('user/check/token')
        .then((resultat) => {
          // verifie si le token exist
          if (!resultat.data.ok) {
            store.state.isUserLoggedIn = false;
            store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
            // verifie  si le token est expiré
            if(err.response.data.ok === false){
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          });
    },
    disabledBeforeToday(date) {
      const today = new Date();
      return date > today;
    },
    disabledAfterToday(date) {
      const today = dayjs(new Date()).add(-1, 'day')
      return date < today;
    },

    dateDiff: function () {
      if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
      let inter = dayjs(this.dateEffet).add(this.duree, 'day').format('YYYY-MM-DD');
      this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
    },

    yearsDiffContractant() {
      const date1 = dayjs(this.ContractantFields.dateNaissance);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.age = daydiff;

      if (this.age <0) {
        this.age = null;
        this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
        this.ContractantFields.dateNaissance = null

      } else if (this.age) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        if(this.age < 18 || this.age <= 0){
          this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
          this.ContractantFields.dateNaissance = null
        }
      }
      else if (this.age<=0) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        if(this.age < 18 || this.age <= 0){
          this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
          this.ContractantFields.dateNaissance = null
        }
      }
    },

    onlyNumber($event) {
      let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
      if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
        $event.preventDefault();
      }
    },

    //Envois des fichiers de formulaire du devis sonac sur l'API desktop vue
    uploadForDesktop(){
      /*let fileNinea = this.$refs.Ninea.files[0];
      let fileRc = this.$refs.Rc.files[0];
      let fileDao = this.$refs.Dao.files[0]
      let fileCni = this.$refs.Cni.files[0]
      let fileLettreType = this.$refs.LettreType.files[0]
      let fileReference = this.$refs.Reference.files[0]
      let fileStatut = this.$refs.Statut.files[0]*/

      if(this.ContractantFields.Duree && this.Beneficiaire){
        this.step = 3
        document.getElementById("secondStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthSecond');
        this.dateEffet = this.dateEffet
        this.duree = this.ContractantFields.Duree
        this.dateDiff()
      }else {
        this.$toasted.show( "Champs obligatoires !", this.ToastTabError)
      }
    },

    //Envois des fichiers de formulaire du devis sonac sur l'API Mobile vue
    uploadForMobile(){
      /*let fileNinea = this.$refs.Ninea.files[0];
      let fileRc = this.$refs.Rc.files[0];
      let fileDao = this.$refs.Dao.files[0]
      let fileCni = this.$refs.Cni.files[0]
      let fileLettreType = this.$refs.LettreType.files[0]
      let fileReference = this.$refs.Reference.files[0]
      let fileStatut = this.$refs.Statut.files[0]*/

      if(this.ContractantFields.Duree && this.Beneficiaire){
        this.step = 3
        document.getElementById("secondStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthSecond');
        this.dateEffet = this.dateEffet
        this.duree = this.ContractantFields.Duree
        this.dateDiff()
      }else {
        this.$toasted.show( "Champs obligatoires !", this.ToastTabError)
      }
    },

    returnToFistStep(){
      this.step = 1
      document.getElementById("secondStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthSecond');
    },

    returnToSecondStep(){
      this.step = 2
      document.getElementById("thirstStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthSix');
    },

    // fonction pour formattage de Date (:-)
    DateFormater: function (TheDate) {
      if (TheDate) {
        return dayjs(TheDate).format("DD-MM-YYYY");
      }
    },

    DevisNextStep(){
      if (!store.state.isUserLoggedIn) {
        this.showLoginForm = true
      }else {
        document.getElementById("firstStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthFirst');
        this.ContractantFields.Nom = this.$store.state.user.nom
        this.ContractantFields.Prenom = this.$store.state.user.prenom
        this.ContractantFields.Email = this.$store.state.user.email
        this.Beneficiaire = this.nom
        this.step = 2
        this.Statut_juridique = this.Structure_legale.libelle
      }
    },

    CalculTaxeRente(){
      this.Simule = true
      this.SkipSimule = false
    },

    GetPrimeNette() {
      const dateEffet = dayjs(this.dateEffet);
      const currentDate = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = dateEffet.diff(currentDate, 'days');
      if(this.nom && this.Structure_legale && this.montant && this.dateEffet){
        if (daydiff == 1) {
          if((Number(this.montant.replace(/[^0-9.-]+/g, "")) >= 1500000)){
            this.prime_nette = (Number(this.montant.replace(/[^0-9.-]+/g, "")) * 1.5 / 100)
            this.taxe = this.prime_nette * 0.1
            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
            this.SkipSimule = true
            this.Simule = false
          }else if((Number(this.montant.replace(/[^0-9.-]+/g, "")) < 1500000) && (Number(this.montant.replace(/[^0-9.-]+/g, "")) >= 100000)){
            this.taxe = 0
            this.prime_nette = 49500
            this.monthly_payment = this.prime_nette + this.accessoire
            this.SkipSimule = true
            this.Simule = false
          }else if((Number(this.montant.replace(/[^0-9.-]+/g, "")) < 100000)) {
            this.$toasted.show( "Le montant doit être supérieur ou égale à 100 000 FCFA!", this.ToastTabError)
          }
        }
        else if (daydiff >= 2) {
          if((Number(this.montant.replace(/[^0-9.-]+/g, "")) >= 1500000)){
            this.prime_nette = ((Number(this.montant.replace(/[^0-9.-]+/g, "")) * 1)/ 100)
            this.taxe = this.prime_nette * 0.1
            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
            this.SkipSimule = true
            this.Simule = false
          }else if((Number(this.montant.replace(/[^0-9.-]+/g, "")) < 1500000) && (Number(this.montant.replace(/[^0-9.-]+/g, "")) >= 100000)){
            this.taxe = 0
            this.prime_nette = 44000
            this.monthly_payment = this.prime_nette + this.accessoire
            this.SkipSimule = true
            this.Simule = false
          }else if((Number(this.montant.replace(/[^0-9.-]+/g, "")) < 100000)) {
            this.$toasted.show( "Le montant doit être supérieur ou égale à 100 000 FCFA!", this.ToastTabError)
          }
        }
        else{
          this.$toasted.show( "la date d'éffet doit être supérieur à la date d'aujourd'hui!", this.ToastTabError)
        }
      }else {
        this.$toasted.show( "Champs obligatoires !", this.ToastTabError)
      }



    },

    isMobile: function () {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },

    isDesktop: function () {
      if (screen.width > 768) {
        return true;
      } else {
        return false;
      }
    },

    getData () {
      this.details = sonacData[0].caution

    },

    CreateDevis: function() {
      if (!store.state.isUserLoggedIn) {
        this.showLoginForm = true
      } else {

        if(this.dateEffet && this.dateEffet!=null && this.dateEcheance && this.dateEcheance!=null )
        {
          const Contractant = {
            Prenom : this.ContractantFields.Prenom,
            Nom : this.ContractantFields.Nom,
            Duree: this.ContractantFields.Duree,
            Beneficiaire: this.Beneficiaire
          };

          let CAUTION = {
            userid: store.state.user._id,
            Prenom: Contractant.Prenom,
            Nom:Contractant.Nom,
            Duree: Contractant.Duree,
            Beneficiaire: Contractant.Beneficiaire,
            Montant:this.montant,
            Statut: this.Structure_legale.libelle,
            dateEffet: this.dateEffet,
            taxe: this.taxe,
            prime_nette:this.prime_nette,
            dateEcheance: this.dateEcheance,
          }

          this.disabledButtonValidate = true
          this.dialogLoading = true;

          Api().post('sonac/create', CAUTION)
              .then((result) => {
                Api().get('devis/' + result.data.devis._id)
                    .then(response => {
                      this.$store.dispatch('setDevisPayement', response.data);
                      this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push('/payement') 
                    })
              }).catch((err) => {
            console.log(err)
          });

          document.getElementById("thirstStep").classList.add('checked');
          document.getElementById("testup").classList.add('widthSix');
        }else{
          this.$toasted.show("Date d'effet et date d'échéance obligatoires !", this.ToastTabError)
        }
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getData()
    this.checkToken()
    $("form").on("change", ".file-upload-field", function(){
      $(this).parent(".file-upload-wrapper").attr("data-text",
          $(this).val().replace(/.*(\/|\\)/, '') );
    });
  }
}
</script>

<style lang="less" scoped>
@import "./../../../assets/css/button.css";
@import "./../../../assets/css/devis_css.css";
@import "./../../../assets/css/assurcare/form_assurcare.css";

.card_width {
  width:170px!important
}
.img_margin_top {
  margin-top : -57%!important;
}
.to-left {
  text-align: left;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.form {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 15px!important;
}

.form .page {
  height: auto;
}

button.next {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
}

button.previous {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}


button.edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

h4 {
  color: #29323a;
  margin-bottom: 15px;
  font-weight: 600;
}

html {
  background-color: #1a1a1a;
  overflow: hidden;
}
.middle {
  width: auto;
  text-align: center;
  /* Made by */
}
.middle h1 {
  font-family: "Inter", sans-serif;
  color: #fff;
}
.middle input[type="radio"] {
  display: none;
}
.middle input[type="radio"]:checked + .box {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409;
  color: #29323a;
}
.middle input[type="radio"]:checked + .box span {
  color: #29323a;
  transform: translateY(70px);
}
.middle input[type="radio"]:checked + .box span:before {
  transform: translateY(0px);
  opacity: 1;
}
.middle .box {
  width: 220px;
  height: 150px;
  border-radius: 12px;
  background-color: #fff;
  transition: all 250ms ease;
  will-change: transition;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: relative;
  box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
  font-size: 10px;
  border: 1px solid #d9dee3;
  font-family: Open Sans,sans-serif;
  font-weight: 900;
}
.middle .box:hover {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409;
}
.middle .box:hover span {
  color: #29323a;
}

.middle .box:active {
  transform: translateY(10px);
}
.middle .box span {
  position: absolute;
  transform: translate(0, 60px);
  left: 0;
  right: 0;
  padding-top: 15%;
  transition: all 300ms ease;
  font-size: 1.5em;
  user-select: none;
  color: #29323a;
}
.middle .box span:before {
  font-size: 1.2em;
  font-family: FontAwesome;
  display: block;
  transform: translateY(-80px);
  opacity: 0;
  transition: all 300ms ease-in-out;
  font-weight: normal;
  color: #fff;
}
.middle p {
  color: #fff;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
.middle p a {
  text-decoration: underline;
  font-weight: bold;
  color: #fff;
}
.middle p span:after {
  content: "\f0e7";
  font-family: FontAwesome;
  color: yellow;
}

.widthFirst{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:33.11112%;
}
.widthSecond{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:65%;
}
.widthThirt{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:48%;
}
.widthFour{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:56%;
}
.widthFive{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:65%;
}
.widthSix{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:100%;
}

.paralax-cover-image {
  background-image: url('./../../../assets/img/assurance/sonac.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 230px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 50px;
}


.paralax-cover-image_mobile {
  background-image: url('./../../../assets/img/assurance/sonac_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  //padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  // background-attachment: fixed;
  background-position: 100% 40px;
}


.hero {
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 680px;
  min-height: 320px;
  max-height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  padding: 20px;
}
.hero .content_home {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin-left: 8.5%;
  z-index: 2;
  /*//background: red;*/
}
.hero .content_home p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}


/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 100;
}


/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 100%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
  transform:  scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
}


/*== speech bubble ==*/
.tool::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 176%;
  color: #EDEFF0;
  font-size:15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
  transform:  scale(.6) translateY(50%);
  width: 17.5em;

}

.tool:hover::after,
.tool:focus::after  {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: .75em;
    margin-left: -5em;
    width: 10em;
  }
}



.muted{
  font-size: 15px;
  margin-left: 2px;
}
.main {
  margin-left: 5px;
}
main_prix{
  margin-left: 10px;
  width: 100px;
}

.new_counter {
  width: 45px;
  border-radius: 0px !important;
  text-align: center;
}
.up_count {
  margin-bottom: 10px;
  margin-left: -4px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  color: #ffa409;
}
.down_count {
  margin-bottom: 10px;
  margin-right: -4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  color: #ffa409;
}


.souscrip_switch input[type="radio"] {
  display: none;
}
.souscrip_switch label {
  position: relative;
  display: inline-block;
  padding: 3px 3px 3px 20px;
  cursor: pointer;
  font-size: 15px;
}
.souscrip_switch label::before,
.souscrip_switch label::after {
  position: absolute;
  content: '';
  top: 50%;
  border-radius: 100%;
  -webkit-transition: all .2s;
  transition: all .2s;
}
.souscrip_switch label::before {
  left: 0;
  width: 14px;
  height: 14px;
  margin-top: -8px;
  background: #f3f3f3;
  border: 1px solid #ccc;
}
.souscrip_switch label:hover::before {
  background: #fff;
}
.souscrip_switch label::after {
  opacity: 0;
  left: 4px;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  background: #ffa409;
  -webkit-transform: scale(2);
  transform: scale(2);
}
.souscrip_switch input[type="radio"]:checked + label::before {
  background: #fff;
  border: 1px solid #ffa409;
}
.souscrip_switch input[type="radio"]:checked + label::after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}







.toggle {
  position: relative;
  width: 82px;
  height: 35px;
  border: 3px solid #f9f9f9;
  border-radius: 40px;
}

.toggle input[type="checkbox"] {
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 84px;
  height: 34px;
}

.toggle .btn {
  display: block;
  position: absolute;
  z-index: 4;
  top: -3px;
  left: -1px;
  width: 37px;
  height: 37px;
  background: #F5F5F5;
  border: 1px solid #e8e8e8;
  border-radius: 100%;
  box-shadow: 0 2px 4px rgba(100, 100, 100, 0.1);
  transition: left .25s ease-in-out;
}

.toggle input[type="checkbox"]:checked ~ .btn {
  left: 44px;
}

.toggle .texts {
  position: absolute;
  top: 9px;
  z-index: 2;
  width: 100%;
  font-family: 'Lato', Helvetica, sans-serif;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
}

.toggle .texts:before {
  content: "Oui";
  position: absolute;
  left: 10px;
}

.toggle .texts:after {
  content: "No";
  position: absolute;
  right: 8px;
}

.toggle .bg {
  display: block;
  background: #F56557;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 40px;
  box-shadow: inset 0 0px 2px 1px rgba(0, 0, 0, 0.3);
  transition: background .25s ease-in;
}

.toggle input[type="checkbox"]:checked ~ .bg {
  background: #48C893;
}

.to-right {
  float: right!important;
}






/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 100;
}


/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 100%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
  transform:  scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
}


/*== speech bubble ==*/
.tool::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 176%;
  color: #EDEFF0;
  font-size:15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
  transform:  scale(.6) translateY(50%);
  width: 17.5em;

}

.tool:hover::after,
.tool:focus::after  {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: .75em;
    margin-left: -5em;
    width: 10em;
  }
}







.card {
  background-color: #fff;
  width: 240px;;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 2rem;
  box-shadow: 0px 1rem 1.5rem rgba(0,0,0,0.1)!important;
}
.card .banner {
  background: #FAFAFA;
  //height: 6rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
}
.card .banner .svg {
  background-color: #fff;
  //width: 8rem;
  //height: 8rem;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);
  border-radius: 50%;
  transform: translateY(50%);
  transition: transform 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28);
  float: left;
}
.card:hover {
  transform: translateY(0.1%) scale(1);
}
.card .menu {
  width: 100%;
  height: 5.6rem;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  position: relative;
  box-sizing: border-box;
}
.card .menu .opener {
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  border-radius: 50%;
  transition: background-color 100ms ease-in-out;
}
.card .menu .opener:hover {
  background-color: #f2f2f2;
}
.card .menu .opener span {
  background-color: #404040;
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0;
  left: calc(50% - 0.2rem);
  border-radius: 50%;
}
.card .menu .opener span:nth-child(1) {
  top: 0.45rem;
}
.card .menu .opener span:nth-child(2) {
  top: 1.05rem;
}
.card .menu .opener span:nth-child(3) {
  top: 1.65rem;
}
.card h2.name {
  text-align: center;
  padding: 0 2rem 0.5rem;
  margin: 0;
  color: #ffa409;
}
.card .title {
  color: #a0a0a0;
  font-size: 0.85rem;
  text-align: center;
  padding: 0 2rem 1.2rem;
}
.card .actions {
  padding: 0 2rem 1.2rem;
  display: flex;
  flex-direction: column;
  order: 99;
}
.card .actions .follow-info {
  padding: 0 0 1rem;
  display: flex;
}
.card .actions .follow-info h2 {
  text-align: center;
  width: 40%;
  margin: 0;
  box-sizing: border-box;
}
.card .actions .follow-info h2 a {
  text-decoration: none;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  border-radius: 0.8rem;
  transition: background-color 100ms ease-in-out;
}
.card .actions .follow-info h2 a span {
  color: #1c9eff;
  font-weight: bold;
  transform-origin: bottom;
  transform: scaleY(1.3);
  transition: color 100ms ease-in-out;
}
.card .actions .follow-info h2 a small {
  color: #afafaf;
  font-size: 0.85rem;
  font-weight: normal;
}
.card .actions .follow-info h2 a:hover {
  background-color: #f2f2f2;
}
.card .actions .follow-info h2 a:hover span {
  color: #007ad6;
}






/*  Toggle Switch  */

.toggleSwitch span span {
  display: none;
}

.toggleSwitch {
  display: inline-block;
  height: 18px;
  position: relative;
  overflow: visible;
  padding: 0;
  margin-left: 30px;
  cursor: pointer;
  width: 40px
}
.toggleSwitch * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.toggleSwitch label,
.toggleSwitch > span {
  line-height: 20px;
  height: 20px;
  vertical-align: middle;
}
.toggleSwitch input:focus ~ a,
.toggleSwitch input:focus + label {
  outline: none;
}
.toggleSwitch label {
  position: relative;
  z-index: 3;
  display: block;
  width: 100%;
}
.toggleSwitch input {
  position: absolute;
  opacity: 0;
  z-index: 5;
}
.toggleSwitch > span {
  position: absolute;
  left: -50px;
  width: 100%;
  margin: 0;
  padding-right: 50px;
  text-align: left;
  white-space: nowrap;
}
.toggleSwitch > span span {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  display: block;
  width: 50%;
  margin-left: 50px;
  text-align: left;
  font-size: 1em;
  width: 100%;
  left: 15%;
  top: -1px;
  opacity: 0;
}
.toggleSwitch a {
  position: absolute;
  right: 50%;
  z-index: 4;
  display: block;
  height: 100%;
  padding: 0;
  left: 2px;
  width: 18px;
  background-color: #fff;
  border: 1px solid #CCC;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.toggleSwitch > span span:first-of-type {
  color: #ccc;
  opacity: 1;
  left: 45%;
}
.toggleSwitch > span:before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50px;
  top: -2px;
  background-color: #fafafa;
  border: 1px solid #ccc;
  border-radius: 30px;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.toggleSwitch input:checked ~ a {
  border-color: #fff;
  left: 100%;
  margin-left: -8px;
}
.toggleSwitch input:checked ~ span:before {
  border-color: #ffa409;
  box-shadow: inset 0 0 0 30px #ffa409;
}
.toggleSwitch input:checked ~ span span:first-of-type {
  opacity: 0;
}
.toggleSwitch input:checked ~ span span:last-of-type {
  opacity: 1;
  color: #fff;
}

body {
  font-family: 'Lato', sans-serif;
}
.container_forma {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.file-upload-wrapper {
  border: 1px solid #d9dee3;
  border-radius: 5px;
  position: relative;
  width: 100%;
  height: 55px;
}
.file-upload-wrapper:after {
  content: attr(data-text);
  font-size: 18px;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  padding: 10px 15px;
  display: block;
  width: calc(100% - 40px);
  pointer-events: none;
  z-index: 20;
  height: 40px;
  line-height: 40px;
  color: #999;
  border-radius: 5px 10px 10px 5px;
  font-weight: 300;
}
.file-upload-wrapper:before {
  content: 'Ajouter';
  position: absolute;
  top: -1px;
  right: -2px;
  display: inline-block;
  height: 55px;
  background: #acabab;
  color: #fff;
  font-weight: 700;
  z-index: 25;
  font-size: 16px;
  line-height: 60px;
  padding: 0 15px;
  text-transform: capitalize;
  pointer-events: none;
  border-radius: 0 5px 5px 0;
}
.file-upload-wrapper:hover:before {
  background: #ffa409;
}
.file-upload-wrapper input {
  opacity: 0;
  border: 2px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 40px;
  margin: 0;
  padding: 0;
  display: block;
  cursor: pointer;
  width: 100%;
}

// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
